<div class="container">
  <div class="step-position">
    {{currentStep}}/{{totalSteps}}
  </div>
  <div class="title">
    {{ title }}
  </div>
  <div class="desciption">
    {{ desciption }}
  </div>
  <div class="navigation-details" mat-dialog-actions>
    <div class="navigation-button">
      @if (totalSteps !== currentStep) {
        <button color="primary" mat-button
        [mat-dialog-close]="0" class="button-dismiss" i18n>Dismiss</button>
      }
      @if (totalSteps !== currentStep) {
        <button color="primary" [mat-dialog-close]="currentStep+1"
        mat-raised-button class="button-next" i18n>Next</button>
      }
      @if (totalSteps === currentStep) {
        <button color="primary" [mat-dialog-close]="0"
        mat-raised-button class="button-done" i18n>Done</button>
      }
    </div>
    <div>

    </div>

  </div>
</div>